<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="!loading" class="notify-wrap">
    <div class="delete-wrapper" @click.prevent="deleteFavourite">
      <div class="icon-delete" />
    </div>
    <label
      v-tooltip="$t('update_noti')"
      class="switch"
      @click.prevent="changeNotify"
    >
      <input
        v-model="notifyCheck"
        type="checkbox"
      >
      <span class="slider round" />
    </label>
  </div>
  <div v-else class="icon-loader" />
</template>

<script>
import { editUserFav, deleteUserFav } from '@/services/user-api'
export default {
  components: { },
  props: {
    favId: {
      type: Number,
    },
    payload: {
      type: String,
    },
    enabledState: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    notifyCheck: {
      get() {
        return this.enabledState
      }
    },
  },
  asyncComputed: {},
  methods: {
    changeNotify() {
      !this.enabledState
      editUserFav(this.favId, this.payload, !this.enabledState).then(resp => {
        if (resp.code === 200) {
          this.$emit('reload-data')
        }
      })
    },
    deleteFavourite() {
      this.loading = true
      deleteUserFav(this.favId).then(resp => {
        if (resp.code === 200) {
          this.$emit('reload-data')
        }
      })
      // //reload data
      // setTimeout(() => {
      //   this.$emit('reload-data')
      // }, 500)
    },
  },
}
</script>

<style lang="stylus" scoped>
.notify-wrap
  display: flex
  align-items: center
  margin-right: vw(8px)
  gap: vw(15px)

  .delete-wrapper
    position: relative
    width: vw(34px)
    height: vw(34px)
    border-radius: 50%
    display: flex
    justify-content: center
    align-items: center
    cursor: pointer

    &:hover
      background-color: $light-grey

    .icon-delete
      m-icon("delete", 26)

  .switch
    position: relative
    display: inline-block
    width: 40px
    height: 22px

  .switch input
    width: 0
    height: 0
    opacity: 0

  .slider
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    background-color: #ccc
    cursor: pointer
    transition: 0.4s
    -webkit-transition: 0.4s

  .slider:before
    position: absolute
    bottom: 2px
    left: 2px
    width: 18px
    height: 18px
    background-color: white
    content: ""
    transition: 0.4s
    -webkit-transition: 0.4s

  input:checked + .slider
    background-color: $grey-dark

  input:focus + .slider
    box-shadow: 0 0 1px $grey-dark

  input:checked + .slider:before
    transform: translateX(18px)
    -webkit-transform: translateX(18px)
    -ms-transform: translateX(18px)

  /* Rounded sliders */
  .slider.round
    border-radius: 34px

  .slider.round:before
    border-radius: 50%
    
.icon-loader
  m-icon("loader", 20)
  margin-left: vw(20px)
  animation: rotate 1s infinite linear

@keyframes rotate
  from
    transform: rotate(0)

  to
    transform: rotate(360deg)
</style>